export default __webpack_public_path__ + "static/media/attachments.689787e6.md";